// extracted by mini-css-extract-plugin
export default {"root":"SetupPhoneModal_root__DHew1","form":"SetupPhoneModal_form__cgrBy","phone":"SetupPhoneModal_phone__r9ysu"};